import { FC } from 'react';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
const FieldBase = (theme: Theme) => css`
  outline: none;
  width: 100%;
  box-sizing: border-box;
  border: 1px solid ${theme.color.surface4};
  border-radius: 8px;
  color: ${theme.color.contentDeep};
  background-color: ${theme.color.surface4};
`;
const TextareaWrap = styled.div<{
  hasError?: boolean;
}>`
  ${({
  theme
}) => FieldBase(theme)}
  position: relative;
  padding: 16px;
  padding-bottom: 30px;
  ${({
  hasError,
  theme
}) => hasError && `
    border-color: ${theme.color.accentA1};
  `}
`;
const TextareaField = styled.textarea`
  padding: 0;
  ${({
  theme
}) => theme.scroll}
  ${({
  theme
}) => FieldBase(theme)}
  resize: none;
  font-size: 16px;
  line-height: 19px;
  caret-color: ${({
  theme
}) => theme.color.primary1};
  &::placeholder {
    color: ${({
  theme
}) => theme.color.content8};
    padding-top: 3px;
  }
`;
const TextareaCount = styled.div<{
  isDone?: boolean;
}>`
  position: absolute;
  ${({
  theme
}) => theme.isRtl ? 'left' : 'right'}: 16px;
  bottom: 16px;
  font-weight: 700;
  font-size: 12px;
  line-height: 14px;
  text-align: ${({
  theme
}) => theme.isRtl ? 'left' : 'right'};
  ${({
  theme,
  isDone
}) => !isDone ? `
    color: ${theme.color.content9};
  ` : `
    color: ${theme.color.primary1};
  `};
`;
interface Props extends React.HTMLProps<HTMLTextAreaElement> {
  hasCount?: boolean;
  countDisplayFormat?: 'remaining' | 'fraction';
}
const Textarea: FC<Props> = ({
  value = '',
  required,
  hasCount,
  countDisplayFormat,
  maxLength,
  onChange,
  ...props
}) => {
  const typedValue = `${value}`;
  const length = typedValue.length;
  const handleChangeInput: React.ChangeEventHandler<HTMLTextAreaElement> = e => {
    if (maxLength) {
      e.target.value = e.target.value.slice(0, maxLength);
    }
    if (onChange) {
      onChange(e);
    }
  };
  return <TextareaWrap hasError={required && !length} data-sentry-element="TextareaWrap" data-sentry-component="Textarea" data-sentry-source-file="index.tsx">
      <TextareaField {...props} value={typedValue} maxLength={maxLength} onChange={handleChangeInput} as='textarea' data-sentry-element="TextareaField" data-sentry-source-file="index.tsx" />
      {hasCount && maxLength && <TextareaCount isDone={maxLength <= length}>
          {countDisplayFormat === 'fraction' ? `${length}/${maxLength}` : maxLength - length}
        </TextareaCount>}
    </TextareaWrap>;
};
export default Textarea;